// import isEmpty from '../../validation/is-empty';

import { SUCCESS_SET_APPLICANT } from "../actions/types";
import {
  MAIN_USER_ID,
  APPLICANT_FROM_SIGN,
  APPLICANT_NAME,
  APPLICANT_SURNAME,
  APPLICANT_I_SUBMITTER_TYPE,
  APPLICANT_GENDER,
  APPLICANT_ISSUED_BY,
  APPLICANT_DOCUMENT_TYPE,
  APPLICANT_TELEPHONE,
  APPLICANT_RNOKPP,
  APPLICANT_FATHER_NAME,
  APPLICANT_NATIONALITY,
  APPLICANT_SERIES,
  APPLICANT_DATE_OF_ISSUE,
  APPLICANT_BANK_ID,
  APPLICANT_DOCUMENT_NUMBER,
  APPLICANT_BITHDAY_DATE,
  APPLICANT_D_DOC_STOP,
  APPLICANT_ACT_RECORD_NUMBER,
  APPLICANT_ACT_RECORD_DATE,
  APPLICANT_UNZR_NUMBER,
  // APPLICANT_ID,
  APPLICANT_RNOKPP_FEATURE,
  APPLICANT_I_APPLICANT,
  APPLICANT_L_ADDRESSESMATCH,
  APPLICANT_DOCUMENT_CLEAR,
  //real address
  APPLICANT_ID_I_APPLICANT,
  APPLICANT_EMAIL,
  APPLICANT_ADDRESS_ID,
  APPLICANT_C_FLAT,
  APPLICANT_C_BUILDING,
  APPLICANT_I_REGION,
  APPLICANT_C_HOUSING,
  APPLICANT_I_POSTINDEX,
  APPLICANT_I_LOCALITY,
  APPLICANT_I_SUBDIVISION,
  APPLICANT_I_STREET,
  APPLICANT_I_ADDRESSTYPE,

  //fact address
  APPLICANT_ID_I_APPLICANT_FACT,
  APPLICANT_ADDRESS_ID_FACT,
  APPLICANT_C_FLAT_FACT,
  APPLICANT_C_BUILDING_FACT,
  APPLICANT_I_REGION_FACT,
  APPLICANT_C_HOUSING_FACT,
  APPLICANT_I_POSTINDEX_FACT,
  APPLICANT_I_LOCALITY_FACT,
  APPLICANT_I_SUBDIVISION_FACT,
  APPLICANT_I_STREET_FACT,
  APPLICANT_I_ADDRESSTYPE_FACT,
  APPLICANT_ADDRESS_FACT_CLEAR,
  APPLICANT_ADDRESS_CLEAR_FACT_REGION,
  //bank
  APPLICANT_P_ACCOUNT,
  APPLICANT_P_MFO,
  APPLICANT_P_EDRPOU,
  APPLICANT_P_NAME,
  APPLICANT_P_ID,
  APPLICANT_CLEAR,
  CLEAR_BANK,
  SET_RNOKPP
} from "../actions/types";

const initialState = {
  mainID: 0,
  i_submittertype: "",
  gender: "",
  issuedby: "",
  documenttype: "",
  telephone: "",
  // rnokpp: "",
  // fathername: "",
  nationality: 1,
  // surname: "",
  series: "",
  dateofissue: "",
  bank_id: 0,
  // name: "",
  documentnumber: "",
  bithdaydate: "",
  id: 0,
  rnokpp_feature: false,
  email: "",
  unzrNumber: "",
  d_doc_stop: "",
  adressfact: {
    id: 0,
    c_flat: "",
    c_building: "",
    i_applicant: 0,
    i_region: "",
    c_housing: "",
    i_postindex: "",
    i_locality: "",
    i_subdivision: "",
    i_street: "",
    i_addresstype: 2,
    l_addressesmatch: ""
  },
  adressreg: {
    id: 0,
    c_flat: "",
    c_building: "",
    i_applicant: 0,
    i_region: "",
    c_housing: "",
    i_postindex: "",
    i_locality: "",
    i_subdivision: "",
    i_street: "",
    i_addresstype: 1,
    l_addressesmatch: ""
  },
  //l_addressesmatch: false,
  //bank
  p_account: "",
  p_mfo: "",
  p_edrpou: "",
  p_name: "",
  p_id: "0",
  enable: {
    0: 0,
    1: 0,
    2: 0,
    3: 0,
    4: 0,
    5: 0,
    6: 0

  }
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SUCCESS_SET_APPLICANT:
      return {
        ...state,
        ...action.payload
      };
    case APPLICANT_ADDRESS_FACT_CLEAR:
      return {
        ...state,
        adressfact: {
          ...state.adressfact,
          ...initialState.adressfact
        }
      };
      case CLEAR_BANK: 
      return {
        ...state,
        p_mfo: '',
        p_edrpou: '',
        p_name: ''
      }
      case APPLICANT_CLEAR:
        return {
          ...state,
          ...initialState,
          adressfact: {
            ...state.adressfact,
            ...initialState.adressfact
          }
        };
    case APPLICANT_DOCUMENT_CLEAR:
      return {
        ...state,
        series: "",
        dateofissue: "",
        issuedby: "",
        documentnumber: "",
        d_doc_stop: ""
      };
    case MAIN_USER_ID:
      return {
        ...state,
        mainID: action.payload
      };
    case APPLICANT_FROM_SIGN:
      return {
        ...state,
        ...action.payload
      };
    case APPLICANT_NAME:
      return {
        ...state,
        name: action.payload
      };
    case APPLICANT_SURNAME:
      return {
        ...state,
        surname: action.payload
      };
    case APPLICANT_I_SUBMITTER_TYPE:
      return {
        ...state,
        i_submittertype: action.payload
      };
    case APPLICANT_GENDER:
      return {
        ...state,
        gender: action.payload
      };
    case APPLICANT_ISSUED_BY:
      return {
        ...state,
        issuedby: action.payload
      };
    case APPLICANT_DOCUMENT_TYPE:
      return {
        ...state,
        documenttype: action.payload
      };
    case APPLICANT_TELEPHONE:
      return {
        ...state,
        telephone: action.payload
      };
    case APPLICANT_RNOKPP:
      return {
        ...state,
        rnokpp: action.payload
      };
    case APPLICANT_FATHER_NAME:
      return {
        ...state,
        fathername: action.payload
      };
    case APPLICANT_NATIONALITY:
      return {
        ...state,
        nationality: action.payload
      };
    case APPLICANT_SERIES:
      return {
        ...state,
        series: action.payload
      };
    case APPLICANT_DATE_OF_ISSUE:
      return {
        ...state,
        dateofissue: action.payload
      };
    //
    case APPLICANT_D_DOC_STOP:
      return {
        ...state,
        d_doc_stop: action.payload
      };
    case APPLICANT_UNZR_NUMBER:
      return {
        ...state,
        unzrNumber: action.payload
      };
    case APPLICANT_ACT_RECORD_NUMBER:
      return {
        ...state,
        actRecordNumber: action.payload
      };
    case APPLICANT_ACT_RECORD_DATE:
      return {
        ...state,
        actRecordDate: action.payload
      };
    case APPLICANT_BANK_ID:
      return {
        ...state,
        bank_id: action.payload
      };
    case APPLICANT_DOCUMENT_NUMBER:
      return {
        ...state,
        documentnumber: action.payload
      };
    case APPLICANT_BITHDAY_DATE:
      return {
        ...state,
        bithdaydate: action.payload
      };

    case SET_RNOKPP:
      const convertToBoolean = parseInt(action.payload);
      return {
        ...state,
        rnokpp_feature: typeof action.payload === "string" ? Boolean(convertToBoolean) : action.payload
      };
    case APPLICANT_RNOKPP_FEATURE:
      const convertToNumber = parseInt(action.payload);
      return {
        ...state,
        rnokpp_feature: action.payload
      };
    case APPLICANT_EMAIL:
      return {
        ...state,
        email: action.payload
      };
    // case APPLICANT_L_ADDRESSESMATCH:
    // return {
    //   ...state,
    //   l_addressesmatch: action.payload
    // };

    //address reg
    case APPLICANT_ID_I_APPLICANT:
      return {
        ...state,
        adressreg: {
          ...state.adressreg,
          i_applicant: action.payload
        }
      };
    case APPLICANT_L_ADDRESSESMATCH:
      return {
        ...state,
        adressreg: {
          ...state.adressreg,
          l_addressesmatch: action.payload
        }
      };
    case APPLICANT_ADDRESS_ID:
      return {
        ...state,
        adressreg: {
          ...state.adressreg,
          id: action.payload
        }
      };
    case APPLICANT_C_FLAT:
      return {
        ...state,
        adressreg: {
          ...state.adressreg,
          c_flat: action.payload
        }
      };
    case APPLICANT_C_BUILDING:
      return {
        ...state,
        adressreg: {
          ...state.adressreg,
          c_building: action.payload
        }
      };
    case APPLICANT_I_APPLICANT:
      return {
        ...state,
        i_applicant: action.payload
      };
    case APPLICANT_I_REGION:
      //console.log(state.applicant);
      return {
        ...state,
        adressreg: {
          ...state.adressreg,
          i_region: action.payload
        }
      };
    case APPLICANT_C_HOUSING:
      return {
        ...state,
        adressreg: {
          ...state.adressreg,
          c_housing: action.payload
        }
      };
    case APPLICANT_I_POSTINDEX:
      return {
        ...state,
        adressreg: {
          ...state.adressreg,
          i_postindex: action.payload
        }
      };
    case APPLICANT_I_LOCALITY:
      return {
        ...state,
        adressreg: {
          ...state.adressreg,
          i_locality: action.payload
        }
      };
    case APPLICANT_I_SUBDIVISION:
      return {
        ...state,
        adressreg: {
          ...state.adressreg,
          i_subdivision: action.payload
        }
      };
    case APPLICANT_I_STREET:
      return {
        ...state,
        adressreg: {
          ...state.adressreg,
          i_street: action.payload
        }
      };
    // case APPLICANT_I_ADDRESSTYPE:
    //   return {
    //     ...state,
    //     adressreg: {
    //       ...state.adressreg,
    //       i_addresstype: action.payload
    //     }
    //   };
    //address fact

    case APPLICANT_ID_I_APPLICANT_FACT:
      return {
        ...state,
        adressfact: {
          ...state.adressfact,
          i_applicant: action.payload
        }
      };
    case APPLICANT_ADDRESS_ID_FACT:
      return {
        ...state,
        adressfact: {
          ...state.adressfact,
          id: action.payload
        }
      };
    case APPLICANT_C_FLAT_FACT:
      return {
        ...state,
        adressfact: {
          ...state.adressfact,
          c_flat: action.payload
        }
      };
    case APPLICANT_C_BUILDING_FACT:
      return {
        ...state,
        adressfact: {
          ...state.adressfact,
          c_building: action.payload
        }
      };
    case APPLICANT_I_REGION_FACT:
      return {
        ...state,
        adressfact: {
          ...state.adressfact,
          i_region: action.payload,
          i_subdivision: '',
          i_locality: '',
          i_street: '',
          i_postindex: '',
         
        }
      };
    case APPLICANT_C_HOUSING_FACT:
      return {
        ...state,
        adressfact: {
          ...state.adressfact,
          c_housing: action.payload
        }
      };

    case APPLICANT_I_POSTINDEX_FACT:
      return {
        ...state,
        adressfact: {
          ...state.adressfact,
          i_postindex: action.payload
        }
      };
    case APPLICANT_I_LOCALITY_FACT:
      return {
        ...state,
        adressfact: {
          ...state.adressfact,
          i_locality: action.payload,
          i_street: '',
          i_postindex: ''
        }
      };
    case APPLICANT_I_SUBDIVISION_FACT:
      return {
        ...state,
        adressfact: {
          ...state.adressfact,
          i_subdivision: action.payload,
          i_locality: '',
          i_street: '',
          i_postindex: '',
        }
      };
    case APPLICANT_I_STREET_FACT:
      return {
        ...state,
        adressfact: {
          ...state.adressfact,
          i_street: action.payload,
          i_postindex: ''
        }
      };
      // case APPLICANT_ADDRESS_CLEAR_FACT_REGION:
      // return {
      //   ...state,
      //   adressfact: {
      //     ...state.adressfact,
      //     i_street: '',
      //     // i_subdivision: '',
      //     i_locality: '',
      //     i_postindex: ''
      //   }
      // };
    // case APPLICANT_I_ADDRESSTYPE_FACT:
    //   return {
    //     ...state,
    //     adressfact: {
    //       ...state.adressfact,
    //       i_addresstype: action.payload
    //     }
    //   };
    //bank
    case APPLICANT_P_ACCOUNT:
      return {
        ...state,
        p_account: action.payload
      };
    case APPLICANT_P_MFO:
      return {
        ...state,
        p_mfo: action.payload
      };
    case APPLICANT_P_EDRPOU:
      return {
        ...state,
        p_edrpou: action.payload
      };
    case APPLICANT_P_NAME:
      return {
        ...state,
        p_name: action.payload
      };
    case APPLICANT_P_ID:
      return {
        ...state,
        p_id: action.payload
      };
    default:
      return state;
  }
}
